module.exports = __webpack_public_path__ + "static/media/atl-logo.44d9a8c3.png";